import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import DriedFruitsProduct from 'models/DriedFruitsProduct'
import DriedFruitsPackage from './DriedFruitsPackage'

const productOptions = {
  packagingInfo: <DriedFruitsPackage />,
  productTitle: 'Dried Fruits',
  model: DriedFruitsProduct,
  validCategories: ['19'],
  validSubCategories: ['004'],
}

const DriedFruits = () => <ProductForm product={productOptions} />

export default DriedFruits

export const getDriedFruitsPackage = newProduct => {
  const newDriedFruitsPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Dried Fruits',
    DFSize: newProduct.DFSize,
    Organic: newProduct.Organic,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    DFType:
      newProduct.DFType === 'Other' ? newProduct.otherType : newProduct.DFType,
    DFPackageType:
      newProduct.DFPackageType === 'Other'
        ? newProduct.otherPackageType
        : newProduct.DFPackageType,
  }
  return newDriedFruitsPackage
}

export const updateDriedFruitsPackage = newProduct => {
  const newDriedFruitsPackage = {
    UPC: newProduct.UPC,
    LegumeProductType: 'Dried Fruits',
    DFType:
      newProduct.DFType === 'Other' ? newProduct.otherType : newProduct.DFType,
    DFPackageType:
      newProduct.DFPackageType === 'Other'
        ? newProduct.otherPackageType
        : newProduct.DFPackageType,
    Organic: newProduct.Organic,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    DFSize: newProduct.DFSize,
  }

  return newDriedFruitsPackage
}
